import React from "react";

const Footer: React.FC = () => {
    return (
        <footer
            style={{
                backgroundColor: "#F4FFFB",
                padding: "20px",
                fontSize: "14px",
                color: "#333",
                display: "flex",
                flexDirection: "column",
                fontFamily: "Lato",
                lineHeight: "1.6",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                }}
            >
                <div
                    style={{
                        alignSelf: "start",
                        flex: 1,
                    }}
                >
                    <img
                        src="assets/images/logo.png"
                        alt="Logo"
                        style={{ width: "150px" }}
                        className="img img-fluid"
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        alignSelf: "end",
                        justifyContent: "end",
                        flexDirection: "row",
                        flex: 0.8,
                        marginBottom: "10px",
                    }}
                >
                    <a
                        href="https://www.linkedin.com/company/re-ecoverse"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            marginRight: "15px",
                        }}
                    >
                        <img
                            src="assets/images/linkedin.png"
                            alt="LinkedIn"
                            style={{ height: "20px" }}
                        />
                    </a>
                    <a
                        href="https://www.instagram.com/rethink_sustainability/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="assets/images/instagram.png"
                            alt="Instagram"
                            style={{ height: "20px" }}
                        />
                    </a>
                    {/* <a
                        href="mailto:rethink@getre.org"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="assets/images/mail.png"
                            alt="Email"
                            style={{ height: "20px" }}
                        />
                    </a> */}
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                }}
            >
                <div
                    style={{
                        fontWeight: 500,
                        fontSize: "16px",
                    }}
                >
                    ✉️{" "}
                    <a
                        href="mailto:rethink@getre.org"
                        style={{
                            textDecoration: "none",
                            color: "#444",
                        }}
                    >
                        rethink@getre.org
                    </a>
                </div>
                <div style={{ fontWeight: 500, fontSize: "14px" }}>
                    📞{" "}
                    <a
                        style={{
                            textDecoration: "none",
                            fontSize: "16px",
                            color: "#444",
                        }}
                        href="tel:+918928545695"
                    >
                        +91-89285 45695
                    </a>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                }}
            >
                <a
                    href="https://rethink.getre.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: "none",
                        textAlign: "center",
                        color: "#444",
                    }}
                >
                    ReThink Sustainability
                </a>
                <a
                    href="https://drive.google.com/file/d/1fp4sy6NSur-ENRjP_PWCw4q7nEAfS04J/view?usp=drivesdk"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: "none",
                        textAlign: "center",
                        color: "#444",
                    }}
                >
                    ReThink Events
                </a>
                <a
                    href="/privacy.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: "none",
                        textAlign: "center",
                        color: "#444",
                    }}
                >
                    Privacy Policy
                </a>
                <a
                    href="/refund.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: "none",
                        textAlign: "center",
                        color: "#444",
                    }}
                >
                    Refund Policy
                </a>
            </div>

            <div
                style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "0 20px",
                    color: "#444",
                    marginTop: "20px",
                }}
            >
                Powered by{" "}
                <a
                    href="https://rethinktravel.org"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "underline", color: "#007bff" }}
                >
                    ReThink Travel
                </a>
                . © {new Date().getFullYear()} All rights reserved.
                <br />
                <span style={{ fontSize: "11px", color: "#777" }}>
                    * calculated based on certain assumptions
                </span>
            </div>
        </footer>
    );
};

export default Footer;
